import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class ModalLang extends Component {

    constructor(props) {
        super(props);
        this.state = {
            temp_lang: ""
        };
    };

    componentWillMount() {
        this.setState({temp_lang: this.props.lang});
    }

    _close(){
        this.props.setLang(false);
    }

    _set(){
        this.props.setLang(this.state.temp_lang);
    }

    _renderText(item) {
        return langRegister.get("modal-lang", item, this.state.temp_lang);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          <img onClick={() => this._close()}
                               className={Styles.overlayCloseButton}
                               src={require("../../assets/images/close_icon_white_3.svg")}/>
                          <div>
                              <div className={Styles.overlayModalTitle}>
                                  {this._renderText("item_1")}
                              </div>
                              <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.overlayModalText}>
                                  <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.overlayModalTextBold}>{this._renderText("item_4")}</span> {this._renderText("item_5")}
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => this._close()}
                                   className={Styles.overlayModalButtonsItemButton}>
                                  {this._renderText("item_2")}
                              </div>
                          </div>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  {this._renderText("item_3")}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalLang;


// WEBPACK FOOTER //
// ./src/components/modal-lang/component.js